import { useEffect, useRef } from "react";

/**
 * Auto-applies a default-value map to a styling state once on mount, but only
 * for keys whose current value is empty/undefined. Keeps user edits intact —
 * if the field was already set (e.g., loaded from a preset), the default is
 * NOT overwritten.
 *
 *   useApplyStyleDefaults(jacketStyling, setJacketStyling, JACKET_MAX_DEFAULTS);
 */
export default function useApplyStyleDefaults(styling, setStyling, defaults) {
  const applied = useRef(false);

  useEffect(() => {
    if (applied.current) return;
    if (!styling || !setStyling) return;
    const patch = {};
    for (const [k, v] of Object.entries(defaults || {})) {
      if (styling[k] === undefined || styling[k] === null || styling[k] === "") {
        patch[k] = v;
      }
    }
    if (Object.keys(patch).length) {
      setStyling({ ...styling, ...patch });
    }
    applied.current = true;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
